import { render, staticRenderFns } from "./AppDownloadInstructions.vue?vue&type=template&id=16531491&"
import script from "./AppDownloadInstructions.vue?vue&type=script&lang=js&"
export * from "./AppDownloadInstructions.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadInstructions.vue?vue&type=style&index=0&id=16531491&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports